// Stablecoin economics — Invest yield spread minus wallet operation subsidy.
//
// Customer-facing copy avoids "gas" and "on-chain transaction" language. The
// model still needs to price the underlying network cost, then cap Pulsar's
// exposure by tier.

function walletOperationsForTier(scenario, tierKey) {
  if (tierKey === 'free') return scenario.freeWalletOperations ?? 0;
  if (tierKey === 'pro') return scenario.proWalletOperations ?? 0;
  return 0;
}

export function userEarnApy(inputs, tier) {
  const gross = inputs.stablecoin?.smartContractYieldApy ?? tier.earnApy ?? 0;
  return Math.max(0, gross - (tier.pulsarYieldSpread ?? 0));
}

export function stablecoinPerUser(inputs, tier, scenario, tierKey) {
  const adoption = scenario.earnAdoptionRate ?? 0;
  const investBalance = (tier.earnAumPerUser ?? 0) * adoption;
  const grossYieldMonthly = (investBalance * (inputs.stablecoin?.smartContractYieldApy ?? 0)) / 12;
  const pulsarYieldMonthly = (investBalance * (tier.pulsarYieldSpread ?? 0)) / 12;
  const userYieldMonthly = Math.max(0, grossYieldMonthly - pulsarYieldMonthly);

  const ops = walletOperationsForTier(scenario, tierKey);
  const rawNetworkCost = ops * (inputs.stablecoin?.avgNetworkCostPerWalletOperation ?? 0);
  const walletOperationCost = Math.min(
    rawNetworkCost,
    tier.walletOperationCostCap ?? rawNetworkCost,
  );
  const networkCostPassThrough = Math.max(0, rawNetworkCost - walletOperationCost);

  return {
    investBalance,
    grossYieldMonthly,
    pulsarYieldMonthly,
    userYieldMonthly,
    walletOperations: ops,
    rawNetworkCost,
    walletOperationCost,
    networkCostPassThrough,
  };
}
